"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _4d_helper_1 = require("./4d-helper");
const rxjs_1 = require("rxjs");
/**
 * <p>Helper class for <a href="https://leafletjs.com/">Leaflet</a>. Contains methods to zoom to a location and add/remove a model to the map.</p>
 * <p>You can play with a(n) (<a href="https://stackblitz.com/edit/angular-demo-leaflet">angular</a> or <a href="https://stackblitz.com/edit/react-demo-leaflet">react</a>) demo on stackblitz.</p>
 */
class LeafletHelper extends _4d_helper_1.MapHelper {
    constructor(map, L) {
        super();
        this.L = L;
        this._objectCache = {};
        this.map = map;
    }
    getAuthenticatedUrl(p, file, tier = 0) {
        return fetch(p.file('DIRECT_TOKEN_URL') + '&tier=' + tier)
            .then(r => r.json())
            .then(r => {
            console.log('\n\n\nr: ', r, '\np: ', p.file('DIRECT_TOKEN_URL'));
            if (r.status == 200 && r.payload.url && r.payload.prefix) {
                var array = r.payload.url.split('?');
                array[0] += r.payload.prefix.substring(0, r.payload.prefix.length - 2) + '/' + file;
                return array;
            }
            return p.file(file).split('?');
        });
    }
    setPlottable(p, args) {
        var opts = {};
        if (p.transformType.uid == 'tms') {
            opts = { tms: true };
        }
        return rxjs_1.from(this.getAuthenticatedUrl(p, '{z}/{x}/{y}.png').then(url => {
            var layer = this.L.tileLayer(url[0] + '?' + url[1], opts);
            layer.addTo(this.map);
            this._objectCache[this.keyFor(p)] = layer;
            return { plottable: p, object: layer };
        }));
    }
    clearPlottables() {
        Object.keys(this._objectCache).forEach(k => this._objectCache[k].remove());
    }
    sendCameraTo(p, duration, args) {
        var zoom = 18;
        var imageBounds = [[p.llat, p.llng], [p.ulat, p.ulng]];
        this.map.flyToBounds(imageBounds, zoom);
        var delaySubject = new rxjs_1.Subject();
        setTimeout(() => delaySubject.next(this.map), duration + 100);
        return delaySubject.asObservable();
    }
    getMapObjectFor(p) {
        return this._objectCache[this.keyFor(p)];
    }
    changeOpacity(t, opacity) {
        throw new Error("Not yet supported");
    }
    resolveItem(movement) {
        throw new Error("Not yet supported");
    }
    /**
     * <p>Generate unique string key for [[PlottableModel]].</p>
     * @param p Uses the [[PlottableModel]]'s classname and id to generate key
     */
    keyFor(p) {
        return '_' + p.className() + '_' + p.id;
    }
}
exports.LeafletHelper = LeafletHelper;
